import { Component,HostListener } from '@angular/core';

@Component({
  selector: 'app-our-team',
  templateUrl: './our-team.component.html',
  styleUrl: './our-team.component.css'
})
export class OurTeamComponent {
  isTransparent = true;
  isMenuOpen = false;
  activeDropdown: number | null = null;

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  toggleDropdown(index: number): void {
    this.activeDropdown = this.activeDropdown === index ? null : index;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
    this.activeDropdown = null;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.nav-item') && !target.closest('.header-toggle')) {
      this.activeDropdown = null;
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isTransparent = offset < 100;
  }

  //Header End

  //Team Members
  teamMembers = [
    {
      name: 'Alexander Harvard',
      position: 'Co Founder',
      image: 'assets/images/team/team-1.jpg',
      socials: [
        { icon: 'bi bi-facebook', link: '#' },
        { icon: 'bi bi-twitter-x', link: '#' },
        { icon: 'bi bi-pinterest', link: '#' }
      ]
    },
    {
      name: 'Jemmy Watson',
      position: 'Designer',
      image: 'assets/images/team/team-2.jpg',
      socials: [
        { icon: 'bi bi-facebook', link: '#' },
        { icon: 'bi bi-twitter-x', link: '#' },
        { icon: 'bi bi-pinterest', link: '#' }
      ]
    },
    {
      name: 'Bobby Castro',
      position: 'Project Lead',
      image: 'assets/images/team/team-3.jpg',
      socials: [
        { icon: 'bi bi-facebook', link: '#' },
        { icon: 'bi bi-twitter-x', link: '#' },
        { icon: 'bi bi-pinterest', link: '#' }
      ]
    },
    {
      name: 'Luara Prior',
      position: 'Data Scientist',
      image: 'assets/images/team/team-4.jpg',
      socials: [
        { icon: 'bi bi-facebook', link: '#' },
        { icon: 'bi bi-twitter-x', link: '#' },
        { icon: 'bi bi-pinterest', link: '#' }
      ]
    }
  ];

  //services
  services = [
    {
      icon: 'bi-transparency',
      title: 'Developing Strategy',
      description: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.'
    },
    {
      icon: 'bi-tools',
      title: 'Blazing Performance',
      description: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.'
    },
    {
      icon: 'bi-rocket-fill',
      title: 'Customer Satisfaction',
      description: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.'
    }
  ];
}
